import { emToPx, pxToRem, remToPx } from '../../helpers/css-units';
import type { ThemeWithoutTokens } from '../theme.types';

export const modalTokens = (theme: ThemeWithoutTokens) =>
  ({
    // backdrop
    modalBackdropBackgroundColor: theme.palette.black,
    modalBackdropOpacity: 0.5,
    modalBackdropZIndex: theme.zIndices.modal,

    // modal
    modalBackgroundColor: theme.colors.body.background,
    modalTextColor: theme.colors.body.text,
    modalShadow: theme.shadows.default,
    modalZIndex: theme.zIndices.modal,
    modalRadius: theme.radiuses.l,
    modalPaddingY: theme.space.component.y.l,

    // modal item (header, body, footer, etc.)
    modalItemPaddingX: theme.space.component.x.m,
    // full width
    modalFullWidthSpaceToSide: theme.space.component.x.m,

    // large
    modalLargeWidth: pxToRem(872),

    // mobile
    modalMobilePaddingY: theme.space.component.y.m,
    modalMobileWidth: '100%',
    modalMobileBottom: '0rem',
    // tablet
    modalTabletWidth: pxToRem(emToPx(theme.devices.tablet.min) - remToPx(theme.space.component.x.s)),
    modalTabletGutterY: '5rem',
    // laptop
    modalLaptopWidth: pxToRem(emToPx(theme.devices.tablet.min) - remToPx(theme.space.component.x.s)),
    modalLaptopGutterY: '10rem',
    // desktop
    modalDesktopWidth: pxToRem(emToPx(theme.devices.tablet.min) - remToPx(theme.space.component.x.s)),
    modalDesktopGutterY: '10rem',
  }) as const;
